import React, {useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import Dropzone from 'react-dropzone'
import AddPhotoAlternateRoundedIcon from '@mui/icons-material/AddPhotoAlternateRounded';

export const DropzoneWrapper = ({ setItem, preview, setPreview }) => {


    const onDrop = (files) => {
        if (!files || files.length === 0) return

        const file = files[0]
        const sizeLimit = 4 * 1024 * 1024 // 4MB

        if (file.size > sizeLimit) {
            console.log('Size Limit Reached')
        return
        }

        setItem((prev)=>({...prev, file: file}))

        const objectUrl = URL.createObjectURL(file)
        setPreview(objectUrl)
    }

    useEffect(() => {
        return () => {
        if (
            preview) URL.revokeObjectURL(preview)
        }
    }, [preview])

    return (
        <Box>
            <Dropzone onDrop={onDrop} accept={{ 'image/*': [] }}>
                {({ getRootProps, getInputProps }) => (
                <Box sx={{ border: 1, borderRadius: 3, borderColor: "#B5BBC1", px: 2, py: 5}}>
                    <div {...getRootProps()}>
                    <input {...getInputProps()} />

                    <Box sx={{display: "flex", justifyContent: "center", flexDirection: "column", gap: 2}}>
                        {preview ? 
                            <Box sx={{display: "flex", justifyContent: "center"}}>
                                <img src={preview} alt="Preview" style={{ maxWidth: '100%', maxHeight: 30, margin: "auto" }}/>
                            </Box>
                        :
                            <AddPhotoAlternateRoundedIcon sx={{color: 'primary.main', m: "auto" , height: 30}}/>
                        }
                        <Typography sx={{fontSize: 12, textAlign: "center"}}>Drag & drop image here, or click to select</Typography>
                    </Box>
                    </div>
                </Box>
                )}
            </Dropzone>
        </Box>
    )
}
